// extracted by mini-css-extract-plugin
module.exports = {"mod-bound":"Bounds_mod-bound__cz_pX"};